import React from 'react';
import type { Reaction } from 'types/interfaces/message';
import './ReactionPills.css';

interface ReactionPillsProps {
  reactions: Reaction[];
  onToggleReaction: (emoji: string) => void;
}

export const ReactionPills: React.FC<ReactionPillsProps> = ({
  reactions,
  onToggleReaction,
}) => {
  if (!reactions || reactions.length === 0) return null;

  return (
    <div className="reaction-pills">
      {reactions.map((reaction) => {
        const isCustom = reaction.emoji.startsWith(':') && reaction.emoji.endsWith(':');
        const tooltipText = reaction.users.length <= 10
          ? reaction.users.map((u) => u.username).join(', ')
          : `${reaction.users.slice(0, 10).map((u) => u.username).join(', ')} +${reaction.users.length - 10} more`;

        return (
          <button
            key={reaction.emoji}
            className={`reaction-pill${reaction.reacted ? ' reaction-pill--active' : ''}`}
            onClick={(e) => {
              e.stopPropagation();
              onToggleReaction(reaction.emoji);
            }}
            title={tooltipText}
            type="button"
          >
            {isCustom && reaction.imageUrl ? (
              <img
                src={reaction.imageUrl}
                alt={reaction.emoji}
                className="reaction-pill__emoji reaction-pill__emoji--custom"
                onError={(e) => {
                  const img = e.currentTarget;
                  const fallback = document.createElement('span');
                  fallback.className = 'reaction-pill__emoji';
                  fallback.textContent = reaction.emoji;
                  img.replaceWith(fallback);
                }}
              />
            ) : (
              <span className="reaction-pill__emoji">{reaction.emoji}</span>
            )}
            {reaction.count > 1 && (
              <span className="reaction-pill__count">{reaction.count}</span>
            )}
          </button>
        );
      })}
    </div>
  );
};
